module.exports = __webpack_public_path__ + "media/images/lb/348-ef4ecf639e1a6240e59c55dbe88803f7.svg";